import { ComponentInstall } from "../../utils";
import Dialog from "./src";

export default ComponentInstall(Dialog);
